import React from 'react';

const ProfileHeaderSkeleton: React.FC = () => {
  return (
    <div className="mb-4 md:mb-10 max-w-[604px] mx-auto animate-pulse">
      <div className="flex gap-5 mb-6">
        <div className="rounded-full md:rounded-[16px] h-[80px] w-[80px] md:h-[188px] md:w-[188px] bg-gray-300 flex-shrink-0" />
        <div className="flex flex-col w-full gap-2 md:gap-3">
          <div className="flex justify-between items-start">
            <div className="flex flex-wrap gap-2 items-center">
              <div className="h-5 md:h-7 w-32 bg-gray-300 rounded" />
              <div className="w-6 h-6 md:w-8 md:h-8 bg-gray-300 rounded-full" />
              <div className="px-2 py-1 rounded-[80px] w-12 h-6 bg-gray-300" />
              <div className="w-5 h-5 md:w-6 md:h-6 bg-gray-300 rounded-full" />
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <div className="flex gap-[10px] md:gap-4">
              <div className="w-20 h-4 bg-gray-300 rounded" />
              <div className="w-20 h-4 bg-gray-300 rounded" />
              <div className="w-20 h-4 bg-gray-300 rounded" />
            </div>

            <div className="flex gap-2 mt-2">
              <div className="w-28 h-4 bg-gray-300 rounded" />
              <div className="w-28 h-4 bg-gray-300 rounded" />
            </div>
            <div className="flex gap-2">
              <div className="w-28 h-4 bg-gray-300 rounded" />
              <div className="w-28 h-4 bg-gray-300 rounded" />
            </div>

            <div className="w-32 h-8 bg-gray-300 rounded mt-2" />
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between mb-2">
        <div className="w-24 h-5 bg-gray-300 rounded" />
      </div>

      <div>
        <div className="space-y-2">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="w-full h-3 bg-gray-300 rounded" />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProfileHeaderSkeleton;
